import { capitalize } from '@/filters/filters'

function genericSplit(splitPoint, val) {
  const tmp = val.substr(splitPoint)
  const upperCase = capitalize(tmp)
  const string = upperCase.split('_').join(' ')
  return string
}

/*
* urn:epcglobal:cbv:bizstep:staging_outbound => Staging outbound
*/
export function bizStepFilter(val) {
  return genericSplit(26, val)
}

/*
* urn:epcglobal:cbv:disp:no_pedigree_match => No pedigree match
*/
export function dispositionFilter(val) {
  return genericSplit(23, val)
}



// WEBPACK FOOTER //
// ./src/components/pages/trackntrace/utils.js